import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sjan-t20-cricket-tournament',
  templateUrl: './sjan-t20-cricket-tournament.component.html',
  styleUrls: ['./sjan-t20-cricket-tournament.component.scss']
})
export class SjanT20CricketTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
